<template>
  <div class="app-home-wrapper">
    <section class="section-item section-one">
      <div class="inner-container">
        <div class="title-text-container">
          {{ `Technological innovation drives the future` }}
        </div>
        <div class="summary-text-container">
          {{
            `We provide leading design software and customized development services, one-stop system integration and information technology solutions`
          }}
        </div>
        <a class="contact-us-button no-user-select" href="mailto:admin@lyantechinnovation.com">{{ `Contact Us` }}</a>
      </div>
    </section>
    <section class="section-item section-two" id="about-us">
      <div class="inner-container">
        <div class="title-text-container">
          {{ `About Us` }}
        </div>
        <div class="summary-text-container">
          {{
            `We are Lyan Tech Innovation Development Co., Ltd., established in 2025, a company focusing on technological innovation and information technology services.`
          }}
        </div>
        <div class="content-container">
          <div class="content-left-part">
            <div class="paragraph-wrapper">
              <div class="paragraph-title">{{ `Our Mission and Vision` }}</div>
              <div class="paragraph-content">
                <div class="content-row-item">
                  {{
                    `Our mission is to promote the digitalization of enterprises through innovative scientific and technological means, provide customers with excellent technical solutions and enhance corporate competitiveness.`
                  }}
                </div>
                <div class="content-row-item">
                  {{
                    `Our vision is to become a leading global information technology service provider, creating a smarter and more efficient future for customers with intelligent and automated technologies.`
                  }}
                </div>
              </div>
            </div>
            <div class="paragraph-wrapper">
              <div class="paragraph-title">{{ `Core Values` }}</div>
              <div class="paragraph-content">
                <div class="content-row-item">
                  {{
                    `Innovation: Continuously break through the limits of technology and lead the industry trend.`
                  }}
                </div>
                <div class="content-row-item">
                  {{
                    `Professional: Provide customers with professional solutions with deep technical accumulation.`
                  }}
                </div>
                <div class="content-row-item">
                  {{
                    `Integrity: Establish a long-term and stable trust relationship with customers to ensure that every delivery exceeds expectations.`
                  }}
                </div>
                <div class="content-row-item">
                  {{
                    `Collaboration: We work closely with customers to face challenges together and share success.`
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="content-right-part"></div>
        </div>
      </div>
    </section>
    <section class="section-item section-three" id="our-services">
      <div class="inner-container">
        <div class="title-text-container">
          {{ `OUR Services` }}
        </div>
        <div class="summary-text-container">
          {{
            `We offer a range of professional services, covering design, development, system integration and technical support, dedicated to providing tailor-made solutions for customers in different industries.`
          }}
        </div>
        <div class="content-container">
          <div class="content-list-wrapper">
            <div class="list-item-wrapper bg-one image-h"></div>
            <div class="list-item-wrapper">
              <div class="part-title">{{ `Software Design Services` }}</div>
              <div class="part-summary">
                {{
                  `We have a strong UI/UX design team that provides professional software design solutions to help companies create product interfaces and experiences that meet user needs.`
                }}
              </div>
              <div class="detail-info-wrapper">
                <div class="detail-title">{{ `Service Content:` }}</div>
                <ul class="detail-content">
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{ `UI Design` }}
                    </div>
                  </li>
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{ `UX Design` }}
                    </div>
                  </li>
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{ `APP and Web Design` }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="content-list-wrapper">
            <div class="list-item-wrapper rtl-row">
              <div class="part-title">{{ `Custom development services` }}</div>
              <div class="part-summary">
                {{
                  `Our development team is dedicated to providing personalized software development services for enterprises. Whether it is web applications, mobile applications, or enterprise-level system development, we can provide high-quality solutions.`
                }}
              </div>
              <div class="detail-info-wrapper">
                <div class="detail-title">{{ `Service Content:` }}</div>
                <ul class="detail-content">
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{
                        `Software Customization Development (Web & Mobile App)`
                      }}
                    </div>
                  </li>
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{
                        `Enterprise application development (ERP, CRM, MIS systems)`
                      }}
                    </div>
                  </li>
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{ `Server development and data processing` }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="list-item-wrapper bg-two rtl-row image-h"></div>
          </div>
          <div class="content-list-wrapper">
            <div class="list-item-wrapper bg-three image-h"></div>
            <div class="list-item-wrapper">
              <div class="part-title">{{ `System Integration` }}</div>
              <div class="part-summary">
                {{
                  `We provide professional system integration services to help enterprises integrate different information systems and hardware to improve overall operational efficiency.`
                }}
              </div>
              <div class="detail-info-wrapper">
                <div class="detail-title">{{ `Service Content:` }}</div>
                <ul class="detail-content">
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{ `System planning and design` }}
                    </div>
                  </li>
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{ `Information system integration` }}
                    </div>
                  </li>
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{ `Network architecture and security solutions` }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="content-list-wrapper">
            <div class="list-item-wrapper rtl-row">
              <div class="part-title">
                {{ `Information Technology Services` }}
              </div>
              <div class="part-summary">
                {{
                  `Our IT services help enterprises cope with technological changes and challenges, provide continuous technical support and maintenance, and ensure high availability and security of systems.`
                }}
              </div>
              <div class="detail-info-wrapper">
                <div class="detail-title">{{ `Service Content:` }}</div>
                <ul class="detail-content">
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{ `Cloud computing and big data solutions` }}
                    </div>
                  </li>
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{ `Enterprise IT Outsourcing Services` }}
                    </div>
                  </li>
                  <li class="detail-row-item">
                    <div class="icon-wrapper">
                      <div class="dot-icon"></div>
                    </div>
                    <div class="text-wrapper">
                      {{ `Technical consulting and training` }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="list-item-wrapper bg-four rtl-row image-h"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-item section-four" id="our-advantages">
      <div class="inner-container">
        <div class="title-text-container">
          {{ `Our Advantages` }}
        </div>
        <div class="summary-text-container">
          {{
            `As an industry innovator, we keep up with global technological trends and are committed to taking the lead in the following technologies:`
          }}
        </div>
        <div class="content-container">
          <div class="content-list-wrapper">
            <div class="list-item-wrapper">
              <div class="item-up-bg bg-one"></div>
              <div class="item-down-container">
                <div class="down-title">{{ `AI and Machine Learning` }}</div>
                <div class="down-summary">
                  {{
                    `Provide customers with intelligent solutions and improve automation level`
                  }}
                </div>
              </div>
            </div>
            <div class="list-item-wrapper">
              <div class="item-up-bg bg-two"></div>
              <div class="item-down-container">
                <div class="down-title">{{ `Big Data and Data Analysis` }}</div>
                <div class="down-summary">
                  {{
                    `Help enterprises optimize operational efficiency through data-driven decision making`
                  }}
                </div>
              </div>
            </div>
            <div class="list-item-wrapper">
              <div class="item-up-bg bg-three"></div>
              <div class="item-down-container">
                <div class="down-title">{{ `Cloud Computing` }}</div>
                <div class="down-summary">
                  {{
                    `Provide enterprises with highly scalable, flexible and secure information technology architecture`
                  }}
                </div>
              </div>
            </div>
            <div class="list-item-wrapper">
              <div class="item-up-bg bg-four"></div>
              <div class="item-down-container">
                <div class="down-title">{{ `Internet of Things (IoT)` }}</div>
                <div class="down-summary">
                  {{
                    `Promote the digital transformation of enterprises through the connection and management of smart devices`
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
@keyframes move-left {
  0% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
  }
  100% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
@-webkit-keyframes move-left {
  0% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
  }
  100% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
@keyframes move-right {
  0% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
  }
  100% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
}
@-webkit-keyframes move-right {
  0% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
  }
  100% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
}
.app-home-wrapper {
  height: 100%;
  width: 100%;
  .section-item {
    display: flex;
    .inner-container {
      flex: 1;
      max-width: 1280px;
      width: 100%;
      margin: 0 auto;
      @media screen and (max-width: 1280px) {
        padding-left: 30px;
        padding-right: 30px;
      }
    }
  }
  .section-one {
    padding-top: 226px;
    min-height: 836px;
    background: linear-gradient(90deg, #000 46.33%, rgba(0, 0, 0, 0.00) 100%),
      url("/images/section-one-bg.png") no-repeat top right;
    background-size: 100% 100%, 1324px 882px;
    @media screen and (max-width: 1324px) {
      background-size: 100% 100%, cover 100%;
    }
    .title-text-container {
      width: 709px;
      font-size: 70px;
      font-weight: 350;
      line-height: 70px;
      color: #ffffff;
      @media screen and (max-width: 930px) {
        width: 100%;
      }
      @media screen and (max-width: 540px) {
        font-size: 50px;
      }
    }
    .summary-text-container {
      margin-top: 40px;
      width: 580px;
      font-size: 20px;
      font-weight: 400;
      line-height: 24px;
      color: #ffffff;
      @media screen and (max-width: 930px) {
        width: 100%;
      }
    }
    .contact-us-button {
      display: block;
      margin-top: 20px;
      min-width: 130px;
      width: 0;
      height: 42px;
      padding: 0px 10px;
      border-radius: 8px;
      background: #357AFC;
      line-height: 42px;
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      &:hover {
        opacity: 0.7;
      }
      &:active {
        opacity: 1;
      }
    }
  }
  .section-two {
    min-height: 732px;
    background: #000;
    padding-top: 80px;
    padding-bottom: 80px;
    .title-text-container {
      font-size: 32px;
      font-weight: 800;
      line-height: 44px;
      color: #ffffff;
      text-align: left;
    }
    .summary-text-container {
      margin-top: 16px;
      font-size: 20px;
      font-weight: 400;
      line-height: 22px;
      color: #ffffff;
    }
    .content-container {
      margin-top: 40px;
      min-height: 450px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 40px;
      @media screen and (max-width: 930px) {
        flex-direction: column-reverse;
      }
      .content-left-part {
        padding-top: 50px;
        padding-bottom: 50px;
        flex: 1;
        .paragraph-wrapper {
          margin-top: 40px;
          &:nth-child(1) {
            margin-top: 0 !important;
          }
          .paragraph-title {
            font-size: 18px;
            font-weight: 500;
            line-height: 22px;
            color: #ffffff;
          }
          .paragraph-content {
            margin-top: 20px;
            .content-row-item {
              font-size: 18px;
              font-weight: 400;
              line-height: 22px;
              color: #8c939d;
              margin-top: 10px;
              &:nth-child(1) {
                margin-top: 0 !important;
              }
            }
          }
        }
      }
      .content-right-part {
        width: 404px;
        height: 380px;
        flex-shrink: 0;
        border-radius: 20px;
        overflow: hidden;
        background: url("/images/section-two-bg.png") no-repeat center center;
        background-size: 100% 100%;
        @media screen and (max-width: 540px) {
          width: 269px;
          height: 253px;
        }
      }
    }
  }
  .section-three {
    min-height: 1732px;
    background: #fff;
    padding-top: 80px;
    padding-bottom: 80px;
    .title-text-container {
      font-size: 32px;
      font-weight: 800;
      line-height: 44px;
      color: #23262f;
      text-align: left;
    }
    .summary-text-container {
      margin-top: 16px;
      font-size: 20px;
      font-weight: 400;
      line-height: 22px;
      color: #8c939d;
    }
    .content-container {
      margin-top: 40px;
      width: 100%;
      .content-list-wrapper {
        margin-top: 30px;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
        gap: 30px 40px;
        align-items: stretch;
        &:nth-child(1) {
          margin-top: 0 !important;
        }
        @media screen and (max-width: 1100px) {
          grid-template-columns: repeat(1, 1fr);
          gap: 16px 20px;
        }
        .list-item-wrapper {
          width: 100%;
          min-height: 329px;
          overflow: hidden;
          border-radius: 10px;
          padding: 50px 20px;
          &.image-h {
            height: 329px;
          }
          &.rtl-row {
            @media screen and (max-width: 1100px) {
              &:nth-child(1) {
                order: 1;
              }
              &:nth-child(2) {
                order: 0;
              }
            }
          }
          &.bg-one {
            background: url("/images/section-third-one.png") no-repeat center
              center;
            background-size: 100% 100%;
          }
          &.bg-two {
            background: url("/images/section-third-two.png") no-repeat center
              center;
            background-size: 100% 100%;
          }
          &.bg-three {
            background: url("/images/section-third-three.png") no-repeat center
              center;
            background-size: 100% 100%;
          }
          &.bg-four {
            background: url("/images/section-third-four.png") no-repeat center
              center;
            background-size: 100% 100%;
          }
          .part-title {
            line-height: 34px;
            font-size: 24px;
            font-weight: 800;
            color: #23262f;
          }
          .part-summary {
            margin-top: 20px;
            color: #8c939d;
            font-size: 18px;
            font-weight: 400;
            line-height: 22px;
          }
          .detail-info-wrapper {
            margin-top: 30px;
            .detail-title {
              color: #8c939d;
              font-size: 18px;
              font-weight: 400;
              line-height: 22px;
            }
            .detail-content {
              margin-top: 4px;
              .detail-row-item {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                gap: 10px;
                .icon-wrapper {
                  flex-shrink: 0;
                  height: 22px;
                  width: 4px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  .dot-icon {
                    flex-shrink: 0;
                    height: 4px;
                    width: 4px;
                    border-radius: 50%;
                    background: #8c939d;
                    overflow: hidden;
                  }
                }
                .text-wrapper {
                  flex: 1;
                  color: #8c939d;
                  font-size: 18px;
                  font-weight: 400;
                  line-height: 22px;
                }
              }
            }
          }
        }
      }
    }
  }
  .section-four {
    min-height: 1028px;
    background: #f6f6f6;
    padding-top: 80px;
    padding-bottom: 80px;
    .title-text-container {
      font-size: 32px;
      font-weight: 800;
      line-height: 44px;
      color: #23262f;
      text-align: left;
    }
    .summary-text-container {
      margin-top: 16px;
      font-size: 20px;
      font-weight: 400;
      line-height: 22px;
      color: #8c939d;
    }
    .content-container {
      padding-top: 32px;
      width: 100%;
      .content-list-wrapper {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
        gap: 32px 32px;
        align-items: stretch;
        @media screen and (max-width: 1100px) {
          grid-template-columns: repeat(1, 1fr);
          gap: 20px 20px;
        }
        .list-item-wrapper {
          min-height: 361px;
          width: 100%;
          border-radius: 10px;
          background: #fff;
          overflow: hidden;
          .item-up-bg {
            height: 220px;
            &.bg-one {
              background: url("/images/section-four-one.png") no-repeat center
                center;
              background-size: 100% 100%;
            }
            &.bg-two {
              background: url("/images/section-four-two.png") no-repeat center
                center;
              background-size: 100% 100%;
            }
            &.bg-three {
              background: url("/images/section-four-three.png") no-repeat center
                center;
              background-size: 100% 100%;
            }
            &.bg-four {
              background: url("/images/section-four-four.png") no-repeat center
                center;
              background-size: 100% 100%;
            }
          }
          .item-down-container {
            padding: 20px;
            .down-title {
              line-height: 28px;
              font-size: 20px;
              font-weight: 800;
              color: #23262f;
              text-align: left;
            }
            .down-summary {
              margin-top: 14px;
              line-height: 22px;
              font-size: 18px;
              font-weight: 400;
              color: #8c939d;
              text-align: left;
            }
          }
        }
      }
    }
  }
  .section-five {
    min-height: 818px;
    padding-top: 80px;
    padding-bottom: 80px;
    background: url("/images/section-five-bg.png") no-repeat top right, #ffffff;
    background-size: 700px 692px, 100% 100%;
    background-position: calc(100% - 31px) 53px;
    @media screen and (max-width: 1280px) {
      background-size: 0px 0px, 100% 100%;
    }
    .title-text-container {
      font-size: 32px;
      font-weight: 800;
      line-height: 44px;
      color: #23262f;
      text-align: left;
    }
    .summary-text-container {
      margin-top: 16px;
      font-size: 20px;
      font-weight: 400;
      line-height: 22px;
      color: #8c939d;
    }
    .content-container {
      padding-top: 32px;
      width: 100%;
      .content-row-item {
        min-height: 246px;
        width: 100%;
        max-width: 654px;
        border-radius: 20px;
        background: rgba(232, 243, 255, 0.5);
        margin-top: 30px;
        padding: 30px 40px;
        &:nth-child(1) {
          margin-top: 0 !important;
        }
        .item-up-wrapper {
          height: 100px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 30px;
          .up-left {
            flex-shrink: 0;
            width: 56px;
            height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
          }
          .up-right {
            flex-shrink: 0;
            width: 100px;
            height: 100px;
            border-radius: 50%;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            &.icon-one {
              background: url("/images/section-five-one.png") no-repeat center
                center;
              background-size: 100% 100%;
            }
            &.icon-two {
              background: url("/images/section-five-two.png") no-repeat center
                center;
              background-size: 100% 100%;
            }
          }
        }
        .item-down-wrapper {
          margin-top: 20px;
          font-size: 18px;
          font-weight: 400;
          line-height: 22px;
          color: #8c939d;
        }
      }
    }
  }
  .partners-show-container {
    height: 100px;
    padding-top: 10px;
    padding-bottom: 10px;
    background: #f6f6f6;
    position: relative;
    overflow: hidden;
    .swiper-outer-wrapper {
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 40px;
      cursor: pointer;
      &:hover {
        .swiper-inner-container {
          animation-play-state: paused !important;
          -webkit-animation-play-state: paused !important;
        }
      }
      .swiper-inner-container {
        flex-shrink: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 40px;
        animation: 40s move-left linear infinite;
        -webkit-animation: 40s move-left linear infinite;
        .swiper-item-wrapper {
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>
